import React from 'react';
import {AppEnv} from "../env";
import {Col, Row} from "react-material-responsive-grid";


export default function Section(props) {
    const {
        bgColor = AppEnv.fourthColor,
        imageName = '../images/separators/web_grayZeroUP.png',
        imageHeight = 'separator',
        imagePosition = 'center',
        padding = '5vh 2vw',
        scrollspy = "cls: uk-animation-slide-left",
        children
    } = props;

    return (
        <Row style={{
            padding: 0,
            margin: 0,
            backgroundColor: bgColor
        }} className=" centerAll uk-width-1-1">
            {imagePosition !== 'none'
                ? <Col style={{padding: '0 2vw', margin: 0}} xl={8} lg={8} md={9} sm={10} xs4={4}>
                    {imagePosition === 'center'
                        ? <Row
                            className="uk-width-1-1 centerAll">
                            <img alt=''
                                 className={"lazyload " + imageHeight}
                                 data-src={imageName}/>
                        </Row>
                        : <Row
                            className="uk-width-1-1 centerAll">
                            {imagePosition !== 'left'
                                ? <Row
                                    className="uk-width-1-2 centerAll"/>
                                : null
                            }
                            <Row
                                className="uk-width-1-2 centerAll">
                                <img alt=''
                                     className={"lazyload " + imageHeight}
                                     data-src={imageName}/>
                            </Row>
                            {imagePosition !== 'right'
                                ? <Row
                                    className="uk-width-1-2 centerAll"/>
                                : null
                            }
                        </Row>}
                </Col>
                : null}
            <Col data-uk-scrollspy={scrollspy} style={{padding: padding, margin: 0}} xl={8} lg={8} md={9} sm={10}
                 xs4={4}>
                {children}
            </Col>
        </Row>
    );
}